import React, { memo } from 'react';
import {
    Dimmer, Header, Icon, SemanticICONS,
} from 'semantic-ui-react';
import { IconSizeProp } from 'semantic-ui-react/dist/commonjs/elements/Icon/Icon';
import * as styles from './ErrorPage.scss';

interface ComponentProps {
    errorHeader: string;
    errorSubHeader?: string;
    errorContent?: string;
    icon?: SemanticICONS;
    iconSize?: IconSizeProp;
}

const ErrorPage = memo(({
    errorHeader, errorSubHeader, errorContent, icon, iconSize,
}: ComponentProps) => {
    return (
        <Dimmer active inverted>
            {icon && <Icon name={icon} size={iconSize} />}
            <Header className={styles.header} as="h2">
                {errorHeader}
                {errorSubHeader && <Header.Subheader>{errorSubHeader}</Header.Subheader>}
            </Header>
            {errorContent && (
                <p>
                    {errorContent}
                </p>
            )}
        </Dimmer>
    );
});

export default ErrorPage;
